import styled from "styled-components";

export const SliderInput = styled.input`
  width: 160px;
  appearance: none;
  border-radius: 60px;
  height: 6px;
  ::-webkit-slider-thumb {
    opacity: 0;
    position: absolute;
    padding: 10px;
    top: -100%;
    cursor: pointer;
  }
  &[disabled] {
    cursor: not-allowed;
    ::-webkit-slider-thumb {
      cursor: not-allowed;
    }
  }
`;

export const SliderWrapper = styled.div<{
  percent?: number;
}>`
  position: relative;
  display: flex;
  align-items: center;
  ${SliderInput} {
    background: ${(p) =>
      `linear-gradient(90deg, var(--main-color) ${p.percent}%, #1B1D20 ${p.percent}% )`};
    ::-webkit-slider-thumb {
      left: ${(p) => `${p.percent}%`};
      transform: ${(p) => `translate(-${p.percent / 2}%, 0)`};
    }
  }
  .slider-thumb {
    position: absolute;
    pointer-events: none;
    left: ${(p) => `${p.percent}%`};
    transform: ${(p) => `translate(-${p.percent / 2}%, 0)`};
  }
`;
